import {
    BooleanInput,
    ImageField,
    ImageInput,
    required,
    TextInput,
    useGetIdentity,
    useRecordContext,
} from 'react-admin';
import { Sale } from '../types';
import { Stack, Grid, Typography, Chip, Box } from '@mui/material';

export function SalesInputs() {
    const { identity } = useGetIdentity();
    const record = useRecordContext<Sale>();
    const isAdmin = identity?.administrator;
    const isSelf = record?.id === identity?.id;

    return (
        <Stack gap={1} sx={{ width: '100%' }}>
            <TextInput
                source="first_name"
                validate={required()}
                helperText={false}
            />
            <TextInput
                source="last_name"
                validate={required()}
                helperText={false}
            />
            <TextInput
                source="email"
                validate={required()}
                helperText={false}
            />
            <BooleanInput
                source="administrator"
                readOnly={isSelf}
                helperText={false}
            />
            <BooleanInput
                source="disabled"
                readOnly={isSelf}
                helperText={false}
            />
            {isAdmin && (
                <Box>
                    <BooleanInput
                        source="approved"
                        label="Approved"
                        helperText={false}
                    />
                    {record?.approved !== undefined && (
                        <Box sx={{ mt: 1 }}>
                            <Chip
                                label={
                                    record.approved
                                        ? 'Approved'
                                        : 'Pending Approval'
                                }
                                color={record.approved ? 'success' : 'warning'}
                                size="small"
                                variant="outlined"
                            />
                        </Box>
                    )}
                </Box>
            )}
        </Stack>
    );
}
